import fetch from '../../api/fetch'

/**
 * 	Action to post data for step04
 *
 *  @param  {object} content [Body to be sent with step04 content]
 *  @param  {string} URL [/quotes/step04]
 * 	@method POST
 */
export function setStep04(content: any) {
    return {
        type: 'SET_STEP04',
        payload: fetch(`/quotes/step04`, { method: 'POST', body: content }),
        quoteId: content.quote.id,
    }
}

export function setStep04c (content: any) {
    return {
        type    : 'SET_STEP04c',
        payload : fetch(`/quotes/collections_locations`, { method: 'POST', body: content }),
        content : content,
    }
}
/**
 * 	Action to post data for step04
 *
 *  @param  {object} content [Body to be sent with step04 content]
 *  @param  {string} URL [/quotes/step04]
 * 	@method POST
 */
export function setStep04Renewals(content: any) {
    return {
        type: 'SET_STEP04',
        payload: fetch(`/renewal/step04`, { method: 'POST', body: content }),
        quoteId: content.quote.id,
    }
}

export function setStep04cRenewals(content: any) {
    return {
        type: 'SET_STEP04c',
        payload: fetch(`/renewal/step04`, { method: 'POST', body: content }),
        quote: content,
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step04.ts